import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { useNavigate , useLocation } from "react-router-dom";
import { BASE_URL } from '../Config/Config';
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";

function GoogleSignin({ mode }) {
  const navigate = useNavigate();
    const location = useLocation();
  
  const { storeToken, setsuccessfully } = UseGlobellogin();
const from = location.state?.from?.pathname || "/";
  
  const showError = (message) => {
    console.error(message); 
  };

  const ClickFunction =()=>{
    console.log("click");
  }
  const handleSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse?.credential) {
        showError("No credentials received from Google.");
        return;
      }

      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Decoded JWT:", decoded);

      const loginData = {
        user_input: decoded.email,
        is_sso: true,
      };

      const apiUrl =
        mode === "login"
          ? `${BASE_URL}/login/`
          : `${BASE_URL}/usersignup/`;
       console.log("loginData",loginData)
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });
      

      const result = await response.json();
      console.log("API Response:", result , "Response : " ,response );
      if (response.ok) {
        setsuccessfully(result.message);

        localStorage.setItem("serverToken", result.access_token);
        localStorage.setItem("userEmail", decoded.email);
        localStorage.setItem("user_id", result.user_id);
        localStorage.setItem("user_Name",decoded.name);
        localStorage.setItem("user_img" ,decoded.picture )
        localStorage.setItem("login_method", 'email');
         window.dispatchEvent(new Event("storage")); 
        storeToken();
        //  mode === "login"
        //   ? navigate("/")
        //   : toggleForm();
        if(from){
          navigate(from);
        }
        else{
          navigate("/")
        }

        // handleClose();
      } else {
        setsuccessfully(result.message);
      }
    } catch (error) {
      console.error("Login Error:", error);
      showError("Something went wrong. Try again.");
    }
  };

  const handleError = () => {
    console.log("Google sign-in error");
    showError("Google sign-in failed. Try again.");
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-center">
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={handleError}
          empty={ClickFunction}
        />
      </div>
    </>
  );
}

export default GoogleSignin;
